import {Component, Input} from '@angular/core';
import { TranslateService } from 'src/modules/base/services/translate.service';

import {SidebarNavHelper} from '../app-sidebar-nav.service';
import { INavData } from '../app-sidebar-nav';

@Component({
    selector: 'app-sidebar-nav-dropdown, cui-sidebar-nav-dropdown',
    template: `
    <a class="nav-link nav-dropdown-toggle"
      appNavDropdownToggle
      [appHtmlAttr]="item.attributes">
      <sidebar-nav-icon-img [item]="item"></sidebar-nav-icon-img>
      <ng-container>{{item | translate_menu | async}}</ng-container>
      @if (helper.hasBadge(item)) {
        <span [ngClass]="item | appSidebarNavBadge">{{ item.badge.text | translate | async }}</span>
      }
    </a>
    <app-sidebar-nav-items
      class="nav-dropdown-items"
      [items]="item.children">
    </app-sidebar-nav-items>
    `,
    styles: [
        '.nav-dropdown-toggle { cursor: pointer; }',
        '.nav-dropdown-items { display: block; }'
    ],
    providers: [SidebarNavHelper],
    standalone: false
})
export class AppSidebarNavDropdownComponent {
  @Input() item: INavData;

  constructor(
    public helper: SidebarNavHelper,
    public translateService: TranslateService

  ) { }

}
